module.exports = __webpack_public_path__ + "img/akkodis-blue-square.780385f1.svg";